import React from 'react';
import {useRouteMatch} from 'react-router-dom';
import {getWindow} from 'ssr-window';
import useConfig from 'hooks/use-config';
import {getCanonicalUrl} from 'utils/page-utils';

/**
 * Handles generation of Canonical URL and meta tag based on route path and environment (prod/non-prod).
 *
 * @param {string} previewPagePattern Pattern for matching preview page (optional)
 * @param {object} window window (optional)
 * @returns {{canonicalURL: string, metaTag: object }} Canonical URL and meta tag (canonical meta tag when non-preview and non-production otherwise robots nofollow).
 */
const useCanonical = (previewPagePattern = '', window = getWindow()) => {
    const {isProduction} = useConfig();

    // eslint-disable-next-line padding-line-between-statements
    const match = useRouteMatch();
    const isPreviewPage = previewPagePattern
        ? new RegExp(previewPagePattern, 'i').test(match.path)
        : false;

    if (isPreviewPage || !isProduction) {
        return {
            canonicalURL: '',
            metaTag: <meta name="robots" content="none" />,
        };
    }

    const canonicalURL = getCanonicalUrl(window.location.href);
    const metaTag = <link rel="canonical" href={canonicalURL} />;

    return {
        canonicalURL,
        metaTag,
    };
};

export default useCanonical;
